import { createContext, useContext, type ReactNode } from 'react'

/**
 * Encaixe do financeiro novo (núcleo) dentro das telas da cirurgia: a página,
 * a gaveta financeira e a aba do caso. A seção da cirurgia não importa a
 * feature do núcleo (fronteira entre features); quem compõe é o shell
 * (`app`), que fornece aqui quem desenha a versão embutida da página do núcleo.
 *
 * Sem provedor (um teste, outro contexto), o valor é `null` e a seção mostra
 * o aviso com o link para a página do núcleo.
 */
export type CoreFinanceSlot = (surgeryId: number) => ReactNode

export const CoreFinanceSlotContext = createContext<CoreFinanceSlot | null>(null)

export function useCoreFinanceSlot(): CoreFinanceSlot | null {
  return useContext(CoreFinanceSlotContext)
}
